import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { layoutActions } from '../store';
import {
  Button, Grid, Typography, Box, Modal, Snackbar, makeStyles} from '@material-ui/core';
import { Stack } from '@mui/material';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '500px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
};
const useStyles = makeStyles(() => ({
  buttons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '33%',
    },
  },
  formContainer: {
    display: 'block',
    width: '100%',
  }

}));

const ShareAccessModal = (props) => {
  const { open, setOpen, deviceId, history } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const user = useSelector((state) => state.session.user);

  const handleModalClose = () => {
    setOpen(false)
  }
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  ///////////////////////////////////////////////////////////////////////////////////

  const onClickReservationID = () => {
    history.push(`/share-reservation/${deviceId}`)
  }
  const onClickSharedUrl = () => {
    history.push(`/share/${deviceId}`)
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    if (open) {
      dispatch(layoutActions.closeDeviceListMenu());
    }
  }, [open]);
  //////////////////////// app modal close feature //////////////////////////////////////////
  const appModalCloseTimestamp = useSelector((state) => state.layout.appModalCloseTimestamp);
  useEffect(() => {
    if (appModalCloseTimestamp) {
      setOpen(false)
    }
  }, [appModalCloseTimestamp]);
  ///////////////////////////////////////////////////////////////////////////////////////////

  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={modalStyle}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarOpen}
            onClose={() => { setSnackbarOpen(false) }}
            autoHideDuration={1500}
            message={toastMessage}
          />
          <div>
            <Stack direction={`row`} sx={{ justifyContent: 'center', alignItems: 'center' }} spacing={2}>
              <Typography variant="h6" component="h2">Share Access By:</Typography>
            </Stack>
          </div>
          <Box sx={{ paddingTop: 16 }}>
            <div>
              <div style={{ maxHeight: 'calc(100vh - 255px)' }}>
                <Box sx={{ maxWidth: '100%', margin: 'auto' }}>
                  <div className={classes.formContainer}>
                    <Grid container justifyContent="space-between" spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Button type="button" color="primary" variant="contained" fullWidth onClick={() => onClickReservationID()}>
                          Reservation ID
                        </Button>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button type="button" color="primary" variant="contained" fullWidth onClick={() => onClickSharedUrl()}>
                          Shared URL
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                </Box>
              </div>
            </div>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default ShareAccessModal;
